module.exports = __webpack_public_path__ + "img/entrance-dt.34a9ff51.png";